require('./style.less');

var PgModeView = require('../pagePgMode'),
    UrlPgView = require('../../url/view'),
    fvChannel = require('glRadio').channel('FV');


/**
 * Underlying urlFrame view should probably extend a pdf view equivalent to that in PDF Mode
 * pdfs options, request mime-type, for example -- see what doing with -- see DVBC-1220 (how loading PDFs in the current pdf container )
 */

module.exports = UrlPgView.extend({


    /*
     *  DVBC-1457: get rid of delay for this page type to make this appear to load faster
     *  Note: can't be 0 -- see reveal function ( addClass callback won't be called )
     *  in the future maybe we apply this to all iframe/url types in page mode
     * */

    FADEIN_TIMER: 1,

    APPLY_SCALE: 0,


    // TODO: here is example of extending the class names
    // TODO: FV-pgWr-PgMode ... why did I need to put this ...

    className: function() {
        return _.result(UrlPgView.prototype, 'className') + ' FV-pgWr-PgMode FV-pgPDF';
    },

    /**
     *
     * If PDF.js, may want to set zoom here since page mode values correspond to PDF.js,
     * though would want to encapsulate in URL function.
     */
    _getCreUrlToLoad: function( creResponse ) {

        return this.vChannel.request('getPdfUrlToLoadInFrame', creResponse);

    },


    _getCRERequestFileName: function() {
        return this.model.getPageName( 'pdf', 1 );
    },


    requestImg: PgModeView.prototype.requestImg,

    // could also put an option if isIE here ...
    // TODO: this is now breaking the position ... application of the iframe shim is breaking it

    _getActionDropDownOptions: function() {

        return  _.extend( {}, PgModeView.prototype._getActionDropDownOptions.call(this), {
            applyIframeShim: 1
        } );

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/pgMode/pgModeGos/view.js
 ** module id = 473
 ** module chunks = 0
 **/